// extracted by mini-css-extract-plugin
export default {"description":"ThirdScreen_description__Xm5Uw","imageContainer":"ThirdScreen_imageContainer__Nc2yo","image":"ThirdScreen_image__RtcR8","title":"ThirdScreen_title__22iy3"};